import { defaultTheme } from "@cobee/cobee-ui";

const theme = {
  ...defaultTheme,
  customProp: "custom-prop-value",
};

export default theme;
